module.exports = __webpack_public_path__ + "static/media/btg_02.a57f6b0c.png";